import {httpGet, httpPost} from "../util";

const CommentsApiErrors = {
  // Referentes al hilo de comentarios, para más info:
  // bbnx-comments/src/Api/Front/Comment/Interfaces/CommentCreateResponseInterface.php
  threadNotFound: 'Hilo de comentarios no encontrado',
  threadNotCommentable: 'Hilo de comentarios bloqueado',
  anonymousCommentsNotAllowed: 'Comentarios anónimos no permitidos',
  userCommentsQuotaExceeded: 'Límite de comentarios permitidos alcanzado',
  userIsNotSubscriber: 'Solo los socios pueden comentar',
  repliesNotAllowed: 'Las respuestas a comentarios no están permitidas',
  userCanNotComment: 'El usuario no puede comentar',
  unknown: 'Desconocido',
  // Referentes a reportes de comentarios, para más info:
  // bbnx-comments/src/Api/Front/Report/Interfaces/ReportCommentResponseInterface.php
  commentNotFound: 'El comentario no ha sido encontrado',
  reportsNotAllowed: 'Los reportes a este comentario no están permitidos',
  anonymousReportsNotAllowed: 'Los reportes anónimos no están permitidos',
  selfReportingNotAllowed: 'No está permitido reportar tus propios comentarios',
  duplicateReport: 'Ya has reportado este comentario',
  // Referentes al voto de comentarios, para más info:
  // bbnx-comments/src/Api/Front/Vote/Interfaces/VoteCommentResponseInterface.php
  votesNotAllowed: 'Los votos no están permitidos',
  negativeVotesNotAllowed: 'No está permitido votar negativamente',
  anonymousVotesNotAllowed: 'Los votos anónimos no están permitidos',
  selfVotingNotAllowed: 'No se pueden votar tus propios comentarios',
  duplicateVote: 'Ya has votado este comentario'
};

const PARTNER_COMMENT = 'partner';
const DEFAULT_COMMENT = 'default';
const AUTHOR_COMMENT = 'author';

const COMMENTS_ENDPOINT = '/api/comment/content/{contentId}';
const HIGHLIGHT_COMMENT_ENDPOINT = '/api/comment/content/{contentId}/featured';
const PARTNER_COMMENTS_ENDPOINT = '/api/comment/content/{contentId}/subscribers';
const VOTE_COMMENT_ENDPOINT = '/api/comment/{commentId}/vote/{isPositive}';
// endpoint para recoger los usuarios que han dado like a un comentario.
const VOTES_COMMENT_ENDPOINT = '/api/comment/{commentId}/votes/{isPositive}';
const REPORT_COMMENT_ENDPOINT = '/api/comment/{commentId}/report';

const MUTED_USERS_ENDPOINT = '/api/comment/user/muted';
const MUTE_USER_ENDPOINT = '/api/comment/user/mute/{userId}';
const UNMUTE_USER_ENDPOINT = '/api/comment/user/unmute/{userId}';

const USER_LIKED_COMMENTS_ENDPOINT = '/api/comment/user/voted';

export {
  PARTNER_COMMENT,
  DEFAULT_COMMENT,
  AUTHOR_COMMENT,
  CommentsApiErrors
}

const CommentsAPI = {
  async fetchComments(contentId, filters) {
    if (!Number.isInteger(contentId)) {
      return
    }
    const endpoint = COMMENTS_ENDPOINT.replace('{contentId}', contentId);
    let url = "";
    const params = [];
    for (const [k, v] of Object.entries(filters)) {
      params.push(`${k}=${v}`);
    }
    if (!params.length) {
      url = endpoint;
    }
    url = `${endpoint}?${params.join('&')}`;
    return await httpGet(url, json => ({
      comments: json.comments,
      totalComments: json.totalComments,
      pages: json.numPages,
      page: json.page
    }));
  },
  async fetchFeaturedComment(contentId) {
    if (!Number.isInteger(contentId)) {
      return
    }
    const url = HIGHLIGHT_COMMENT_ENDPOINT.replace('{contentId}', contentId);
    return await httpGet(url, json => {
        const [highLightComment] = json.comments;
        return {
          comment: highLightComment
        };
      });
  },
  async fetchPartnerComments(contentId) {
    if (!Number.isInteger(contentId)) {
      return
    }
    const url = PARTNER_COMMENTS_ENDPOINT.replace('{contentId}', contentId);
    return await httpGet(url, ({ comments }) => ({ comments }));
  },
  async createComment(contentId, text, repliedCommentId) {
    if (!Number.isInteger(contentId)) {
      return
    }
    const url = COMMENTS_ENDPOINT.replace('{contentId}', contentId);
    return await httpPost(url, json => json, { text, repliedCommentId });
  },
  async report(commentId) {
    if (!Number.isInteger(commentId)) {
      return
    }
    const url = REPORT_COMMENT_ENDPOINT.replace('{commentId}', commentId);
    await httpPost(url);
  },
  async vote(commentId, isPositive) {
    if (!Number.isInteger(commentId)) {
      return
    }
    const url = VOTE_COMMENT_ENDPOINT.replace('{commentId}', commentId).replace('{isPositive}', Number(isPositive));
    await httpPost(url);
  },
  async votes(commentId, isPositive) {
    if (!Number.isInteger(commentId)) {
      return
    }
    const url = VOTES_COMMENT_ENDPOINT.replace('{commentId}', commentId).replace('{isPositive}', Number(isPositive));
    return await httpGet(url, ({ users}) => users.map(({ nick, profileUrl}) => ({ nick, profileUrl })));
  },
  async mutedUsers() {
    return await httpGet(MUTED_USERS_ENDPOINT, ({ userIds }) => userIds);
  },
  async muteUser(userId) {
    const url = MUTE_USER_ENDPOINT.replace('{userId}', userId);
    await httpPost(url);
  },
  async unmuteUser(userId) {
    const url = UNMUTE_USER_ENDPOINT.replace('{userId}', userId);
    await httpPost(url);
  },
  async userLikedCommentIds() {
    return await httpGet(USER_LIKED_COMMENTS_ENDPOINT, ({ commentsId }) => commentsId);
  }
};

export default CommentsAPI;
